import apiFetch from '@wordpress/api-fetch';

const {__} = wp.i18n;
const $ = jQuery;

const AdminSettings = {
    bindEvents: () => {
        const button = document.querySelector('.csp-plugin-start-transaction-button');
        if (button) {
            button.addEventListener('click', AdminSettings.clickHandle)
        }

        const progress = document.querySelector('#csp-plugin_sync_progress');
        if (progress) {
            setInterval(() => {
                AdminSettings.followSynchronization();
            }, 10000);
        }
    },
    followSynchronization: () => {
        apiFetch({
            path: '/csp-plugin/v1/related-posts/nb-already-synced',
            method: 'GET',
        }).then((response) => {
            document.querySelector('#csp-plugin_sync_progress').setAttribute("value", response.nbPostSynced);
            document.querySelector('#csp-plugin_setting_sync_count').setAttribute("value", response.nbPostSynced);
            document.querySelector('#csp-plugin_sync_indicator').innerHTML = response.nbPostSynced;
        }).catch((err) => {
            console.error(err);
        });
    },
    clickHandle: (e) => {
        const button = e.target;
        e.preventDefault();

        const ajaxUrl = button.getAttribute('data-ajaxurl');
        const data = {
            action: button.getAttribute('data-action'),
            nonce: button.getAttribute('data-nonce')
        }

        fetch(ajaxUrl, {
            method: 'POST', headers: {
                'Content-Type': 'application/x-www-form-urlencoded', 'Cache-Control': 'no-cache',
            }, body: new URLSearchParams(data),
        })
            .then(response => response.json())
            .then(response => {
                if (!response.success) {
                    alert(__('An error occurred and the synchronization could not start', 'csp-plugin'))
                    throw new Error(`Response content : ${response.data}`);
                }

                return response.data;
            })
            .then(({synchId}) => {
                const noticeText = __('Synchronization n°%d started.', 'csp-plugin').replace('%d', synchId);
                $('.wrap').prepend(`<div class='notice notice-success dismiss-after-delay'><p><strong>${noticeText}</strong></p></div>`);
                setTimeout(() => {
                    $('.dismiss-after-delay').remove();
                }, 20000);
            })
            .catch(error => console.error(error));
    }
};

export default AdminSettings;
